import * as classnames from 'classnames/bind';
import * as React from 'react';

const styles = require('./Spinner.less');
const cx = classnames.bind(styles);

export enum SpinnerSize
{
    Medium_16 = 16,
    Medium_20 = 20,
    Medium_24 = 24,
    Large_32 = 32,
    Large_48 = 48,
    Large_64 = 64
}

export enum SpinnerStyle
{
    MultiColor = 'MultiColor',
    White = 'White',
    Blue = 'Blue'
}

export enum SpinnerWeight
{
    Thin = 2,
    Normal = 1
}

export interface SpinnerProps
{
    size?:SpinnerSize | number;
    style?:SpinnerStyle;
    weight?:SpinnerWeight | number;
    className?:string;
}

export class Spinner extends React.Component<SpinnerProps, any>
{
    public shouldComponentUpdate(nextProps:SpinnerProps):boolean
    {
        const {size, style, weight, className} = this.props;

        return (
            size !== nextProps.size ||
            style !== nextProps.style ||
            weight !== nextProps.weight ||
            className !== nextProps.className
        );
    }

    public render():JSX.Element
    {
        const {
            size = SpinnerSize.Medium_16,
            style = SpinnerStyle.MultiColor,
            weight = SpinnerWeight.Normal,
            className
        } = this.props;

        const radius = size >= SpinnerSize.Large_64 ? 30 : 22;
        const strokeWidth = size >= SpinnerSize.Large_64 ? 6 : 10;

        return (
            <svg
                className={cx('spinner',
                    {'multiColorSpinner': style === SpinnerStyle.MultiColor},
                    {'whiteSpinner': style === SpinnerStyle.White},
                    {'blueSpinner': style === SpinnerStyle.Blue},
                    className)
                }
                width={size}
                height={size}
                viewBox="0 0 66 66"
            >

                <circle className={cx('path')}
                        fill="none"
                        strokeWidth={weight !== 0 ? strokeWidth / weight : strokeWidth}
                        strokeLinecap="round"
                        cx="33"
                        cy="33"
                        r={radius} />
            </svg>
        );
    }
}





